import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import './Navbar.scss';
import logo from '../../../images/logo-contigo-white.png';
import {IconButton} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import commonAction from '../../common.actions';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const Navbar = () => {
  const isLoggedIn = useSelector((state) => state.login.isLoggedIn);
  const dispatch = useDispatch();

  return (
    <div className="nav-div-background">
      { isLoggedIn &&
        <IconButton edge="start" className="nb-ib" onClick={() => dispatch(commonAction.toggleSideBar())} >
          <MenuIcon />
        </IconButton>
      }
      <img src={logo} onClick={() => window.location.href = '/'} alt='logo' />
    </div>
  );
};

Navbar.propTypes = {

};

export default Navbar;

